import { useQuery } from "@tanstack/react-query";

import { FeatureQueryKeys } from "./keys";
import useApiHelper from "../../hooks/useApiHelper";
import { IFeature } from "../../models/Feature/Feature";
import { IDefaultResponse } from "../../models/DefaultResponse";

export default function useFeatures() {
  const { get } = useApiHelper();

  const features = useQuery({
    queryKey: FeatureQueryKeys.all(),
    queryFn: () =>
      get<IDefaultResponse<IFeature[]>>("/feature").then((res) => res.data),
  });

  return {
    features,
  };
}
